import { createSlice } from '@reduxjs/toolkit';
import fetchRadiologistUser from '@custom/rtk-apis/radiologistuser/getRaidologiestuser';

// Define the initial state
const initialState = {
  status: '',
  result: [],
  msg: '',
  loading: false,
  error: '',
};

const radiologistUserSlice = createSlice({
  name: 'radiologistUserSlice',
  initialState,
  reducers: {
    // Reducer to reset the state to its initial values
    resetradiologistUser: (state) => {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    console.log('----------', builder);
    builder
      .addCase(fetchRadiologistUser.pending, (state) => {
        console.log('Pending');
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchRadiologistUser.fulfilled, (state, { payload }) => {
        console.log('Fulfilled', payload);
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(fetchRadiologistUser.rejected, (state, { error }) => {
        console.log('Rejected');
        state.loading = false;
        state.error = error.message || 'Something went wrong';
      });
  },
});

export const { resetradiologistUser } = radiologistUserSlice.actions;

export default radiologistUserSlice.reducer;
